import { useDispatch, useSelector } from "react-redux";
import { ConfigInit, ModalsAction, UserSession } from "src/store";
import { Avatar } from "src/components/ui/avatar";
import { ArrowLeft, Edit, History, Logout, Package, Devices, Favorite } from "../svg";
import { _ } from "src/services";
import { NavLink } from "react-router-dom";
import { useHistory, useParams } from "react-router";

export const ProfileMenu: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const { route } = useParams<{ route?: string }>();
    const history = useHistory();
    const user: UserSession = useSelector((state: any) => state.UserState);
    const config: ConfigInit = useSelector((state: any) => state.ConfigState);

    //#end region

    //#region properties

    const currentUser = {
        fullName: user.user?.fullName || _("fullNamePlaceholder"),
        phone: user.user?.msisdn || "...",
    };

    //#end region

    //#region  methods

    const logout = () => {
        dispatch(ModalsAction.showLogout());
    };

    const onNameClick = () => {
        !user.user?.fullName && history.push("/profile/edit");
    };

    const openGift = () => dispatch(ModalsAction.showGift());


    //#end region



    return (
        <div className="profile-menu">
            <div className="profile-menu--header">
                <div className="page-profile--avatar-area">
                    <Avatar />
                </div>
                <div className="profile-menu--name">
                    <h4 className={user.user?.fullName ? "" : "no-name"} onClick={onNameClick}>{currentUser.fullName}
                        {!user.user?.fullName && <ArrowLeft width="20" height="20" />}
                    </h4>
                    <h5>{currentUser.phone}</h5>
                    <button onClick={openGift} className="btn-gift">
                        <span>{_("addGiftCode")}</span>
                    </button>
                </div>
                <NavLink className="btn btn-link text-white" to="/profile/edit">
                    <Edit />
                </NavLink>
            </div>
            <ul className="profile-menu-items">
                <li className={`${!route ? "desktop-active" : ""}${route === "subscription" ? " active" : ""}`}>
                    <NavLink to="/profile/subscription">
                        <Package />
                        <span>{_("yourPackages")}</span>
                        <span className="flex-1"></span>
                        <span className="d-lg-none"><ArrowLeft width="24" height="24" /></span>
                    </NavLink>
                </li>
                <li className={route === "purchases" ? "active" : ""}>
                    <NavLink to="/profile/purchases">
                        <History />
                        <span>{_("purchases")}</span>
                        <span className="flex-1"></span>
                        <span className="d-lg-none"><ArrowLeft width="24" height="24" /></span>
                    </NavLink>
                </li>
                {config.config.appSetting.devicesProfileEnabled &&
                    <li className={route === "devices" ? "active" : ""}>
                        <NavLink to="/profile/devices">
                            <Devices />
                            <span>{_("devices")}</span>
                            <span className="flex-1"></span>
                            <span className="d-lg-none"><ArrowLeft width="24" height="24" /></span>
                        </NavLink>
                    </li>
                }
                {config.config.appSetting.favoritesEnabled &&
                    <li className={route === "favorites" ? "active" : ""}>
                        <NavLink to="/profile/favorites">
                            <Favorite />
                            <span>{_("favorites")}</span>
                            <span className="flex-1"></span>
                            <span className="d-lg-none"><ArrowLeft width="24" height="24" /></span>
                        </NavLink>
                    </li>
                }
                <li>
                    <button onClick={logout}>
                        <Logout />
                        <span>{_("logout")}</span>
                    </button>
                </li>
            </ul>
        </div>
    );
};